<template>
    <!-- <v-card class="elevation-0"> -->
    <div id="buyer_comparison_wrapper">
        <v-dialog 
            v-model="buyerQuestionnaire_dialog" 
            transition="dialog-bottom-transition"
            max-width="83%"
            scrollable>
            <v-card>
                <v-card-title class="info pewter--text d-flex justify-space-between">
                    <div class="justify-start mr-12">{{ thisBuyer.buyer_fullname }}</div>
                    <div class="d-flex flex-grow-1">
                        <div class="justify-start mr-6">{{ thisBuyer.email }}</div>
                        <v-divider v-if="thisBuyer.phone" vertical class="pewter"></v-divider>
                        <div class="justify-center mx-6">{{ thisBuyer.phone }}</div>
                        <v-divider v-if="thisBuyer.location_text" vertical class="pewter"></v-divider>
                        <div class="justify-end ml-6">{{ thisBuyer.location_text }}</div>
                    </div>
                    <div class="justify-end">
                        <v-btn 
                            icon 
                            dark 
                            class="ml-3"
                            @click="buyerQuestionnaire_dialog = false">
                            <v-icon color="pewter">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text>
                    <BuyerQuestionnaire 
                        :user_id="thisBuyer.buyer_id"
                        :is_secondary="thisBuyer.is_secondary"
                        :project_id="thisBuyer.project_id"
                        :module_key="moduleKey"
                        :module_id="moduleId"
                        :isOpen="buyerQuestionnaire_dialog"
                    />
                </v-card-text>
                <v-card-actions class="info">
                    <v-spacer></v-spacer>
                    <!-- LEAVE COMMENTED IN CASE WE DON'T LIKE THE FIXED HEIGHT
                    <v-btn
                        outlined
                        color="pewter"
                        class="mr-3"
                        @click="buyerQuestionnaire_dialog = false">
                        close
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-navigation-drawer 
            v-model="notesDialog"
            temporary
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">                
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Notes for {{ thisBuyer.buyer_fullname }}
                    </div>
                    <div class="d-inline">
                        <v-btn
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            :disabled="notesSaving"
                            @click="notesDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                
                <v-card-text class="mt-12">
                    <WysiwygEditor
                        :key="`quick-notes-${thisBuyer.buyer_dashboard_row_key}`"
                        :value="thisBuyer.notes || ''"
                        @input="val => $set(thisBuyer, 'notes', val)"
                        style="width: 100%;"
                        :toolbar="quickNotesToolbar">
                    </WysiwygEditor>
                </v-card-text>
                
                <v-card-actions class="px-4">
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="primary lighten-2 info--text" 
                        class="ml-3"
                        @click="saveNotes(thisBuyer)">
                        save note
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-navigation-drawer>

        <BuyerStatusDrawer
            v-model="statusDrawer"
            :buyers="selectedBuyers"
            :statusId="selectedStatus"
            :statusList="buyer_status"
            :listingId="$route.params.lid"
            :listingIdentifier="listing_identifier"
            @input="open => { if (!open) selectedStatus = null }"
            @updated="statusUpdated"
            @failed="message => triggerUserFeedback( true, message, 'accent', 3000 )" />

        <div class="d-flex  primary--text text--darken-1 py-5 px-3 justify-space-between align-center">
            <!-- Interested Buyers -->
            <!-- <BuildTitle :listing_identifier="listing_identifier" /> -->
            <div class="d-inline sansation_subtitle font-weight-thin">
                {{ listing_identifier }} <v-divider vertical class="mx-3" color="black"></v-divider> {{ buyerCounts.buyer_cnt }} of {{ buyerCounts.total_cnt }} interested buyers left
            </div>
            <div class="d-inline">
                <v-menu
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            class="mr-3 elevation-1"
                            color="primary darken-1"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Calculate Scores
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item 
                        @click="getCompatibilityScore(false)"
                        >
                            <v-list-item-title>Calculate</v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                        @click="getCompatibilityScore('scores')"
                        >
                            <v-list-item-title>Calculate and Export Scores</v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                        @click="getCompatibilityScore('breakdown')"
                        >
                            <v-list-item-title>Calculate and Export Score Breakdown</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-btn
                    outlined
                    color="primary darken-1"
                    hide-details
                    class="mr-3 elevation-1"
                    :loading="exporting"
                    :disabled="exporting"
                    @click="exportBuyers()">
                    Export
                </v-btn>
                <v-btn 
                    outlined
                    color="primary darken-1" 
                    class="ml-3 elevation-1"
                    @click="closeBuyers()">
                    Close
                </v-btn>
            </div>
        </div>

        <div class=" pt-0 pb-4 px-2" flat>
            <div class="d-flex mx-1 mb-1 py-2 justify-space-between">
                <div class="d-inline" style="width:35%">
                    <v-select 
                        v-model="selectedStatus"
                        :items="buyer_status"
                        @change="openStatusDrawer()"
                        hide-details
                        label="Select Buyers First > Then Change Status">
                    </v-select>
                </div>
                <div class="d-inline" style="width:58%">
                    <v-text-field
                        v-model="buyer_search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        class="d-block">
                    </v-text-field>
                    <div class="d-block d-flex mt-3" style="gap: 24px;">
                        <v-autocomplete
                            v-model="filterby.status"
                            :items="buyer_status"
                            item-text="text"
                            item-value="value"
                            label="Filter by Status"
                            clearable
                            multiple
                            hide-details
                            color="primary darken-1"
                            style="width: 46%;"
                            @change="filterBuyers()">
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="filterOutRejected()">
                                    <v-list-item-content>
                                        Filter out Rejected
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                            </template>
                        </v-autocomplete>

                        <v-autocomplete
                            v-model="filterby.state"
                            :items="state_options"
                            label="State"
                            clearable
                            multiple
                            hide-details
                            color="primary darken-1"
                            style="width: 22%;"
                            @change="filterBuyers()">
                        </v-autocomplete>

                        <v-autocomplete
                            v-model="filterby.aum"
                            :items="aum_ranges"
                            item-text="text"
                            item-value="value"
                            label="AUM"
                            clearable
                            multiple
                            hide-details
                            color="primary darken-1"
                            style="width: 32%;"
                            @change="filterBuyers()">
                        </v-autocomplete>
                    </div>
                    <div class="d-flex justify-end align-center mt-3">
                        <span v-if="filtered_buyers_cnt">{{ filtered_buyers_cnt }} total results</span>
                        <v-btn
                            v-if="hasActiveFilters"
                            x-small
                            text
                            color="primary darken-1"
                            class="ml-3"
                            @click="clearFilters()">
                            Clear Filters
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>

        <v-data-table
            v-model="selectedBuyers"
            :headers="buyers_header"
            :items="interested_buyers"
            :options.sync="options"
            @update:options="onUpdateOptions"
            :search="buyer_search"
            @current-items="getFilteredCount"
            item-key="buyer_id"
            loader-height="6"
            :loading="readyToLoadBuyers"
            loading-text="Pulling buyers ..."
            show-select
            some-items
            multi-sort
            fixed-header
            :height="'calc(100vh - 370px)'"
            class="srg-data-table buyers-table narrow-select-col"
        >

            <template v-slot:no-data>
                <div class="text-center pt-12">
                    <v-icon large>mdi-alert-circle</v-icon>
                    <p class="mt-2">No buyers found matching your filters.</p>
                </div>
            </template>

            <template v-slot:item="{ item }">
                <tr :key="item.id">
                    <td class="ma-0 pa-0 pt-2">
                        <v-checkbox 
                            v-model="selectedBuyers" 
                            :value="item"
                            hide-details
                            class="ma-0 pa-0 ml-n1 mr-n9" />
                    </td>
                    <td class="text-start">
                        <div class="d-flex d-block justify-space-between pr-2">
                            <strong>{{ item.buyer_fullname }}</strong>

                            <div class="justify-end">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-if="item.is_badbuyer" v-on="on" small class="mt-n1" color="brown">mdi-emoticon-poop</v-icon>
                                    </template>
                                    <span>Bad Buyer</span>
                                </v-tooltip>
                            </div>
                        </div>
                        <div class="d-flex d-block justify-space-between pr-2">
                            <div style="cursor:pointer"
                                class="my-1 primary--text"
                                @click="buyerQuestionnaire(item)">
                                buyer data
                            </div>
                            <div class="justify-end pt-1">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-if="item.show_progress" v-on="on" small :color="item.progress_color">mdi-alert</v-icon>
                                    </template>
                                    <span>{{ item.progress_text }}</span>
                                </v-tooltip>
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-if="item.is_archived" v-on="on" small color="accent">mdi-archive-cancel</v-icon>
                                    </template>
                                    <span>Buyer archived interest</span>
                                </v-tooltip>
                            </div>
                        </div>
                        <div class="d-block smaller_date">Last Saved: {{ item.last_saved_date_text }}</div>
                    </td>
                    <td class="text-left">{{ item.state_text }}</td>
                    <td class="text-left">{{ item.aum_text }}</td>

                    <td class="text-left" v-html="item.revenue_vs_text"></td>
                    <td class="text-left">{{ item.afp_pct }}</td>
                    <td class="text-left">{{ item.commissions }}</td>

                    <td class="text-left">{{ item.broker_dealer }}</td>
                    <td class="text-left">
                        <span v-for="(custodian, idx) in item.custodians" :key="custodian">{{ custodian }}{{ item.custodians.length > 1 && item.custodians.length > (idx+1) ? ',':''}}<br></span>
                    </td>
                    <td class="text-left">
                        <span v-for="(tamp, idx) in item.tamps" :key="idx">{{ tamp }}{{ item.tamps.length > 1 && item.tamps.length > (idx+1) ? ',':''}}<br></span>
                    </td>
                    <td class="text-left">{{ item.created_date_text }}</td>
                    <td class="text-left">{{ item.compatibility ? `${(item.compatibility.split('/')[0]/item.compatibility.split('/')[1] * 100).toFixed(0)}%` : null  }} {{ item.compatibility ? `(${item.compatibility})` : '' }} </td>
                    <td class="text-left">{{ item.adjustedScore ? item.adjustedScore : null  }} </td>
                    <td class="text-left">
                        <div class="d-block">
                            <div class="d-block" v-if="item.show_rejected_date">Rejected Date: {{ item.status_change_date_text }}</div>
                            <div class="d-block">{{ item.status_name }}</div>
                        </div>
                        <v-btn
                            dark
                            x-small
                            elevation="0"
                            class="d-block mt-1"
                            :color="item.notes != null ? 'primary' : 'grey lighten-1'"
                            @click="buyerNotes(item.id)">
                            <v-icon small dark>mdi-pencil</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>


<script>  
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    import { saveAs } from 'file-saver';
    import { formatBigInt } from '../helpers/utilities'
    import { safeParseJson } from '../helpers/safe-json';
    import { ExportToCsv } from 'export-to-csv';

    import BuyerQuestionnaire from './ModuleQuestionnaire'
    import BuyerStatusDrawer from './shared/BuyerStatusDrawer.vue'
    import WysiwygEditor from "./WysiwygEditor.vue";
    import { quickNotesToolbar } from './shared/editorToolbars'
  
    export default {
        name: 'BuyerComparison',

        components: {
            BuyerQuestionnaire,
            BuyerStatusDrawer,
            WysiwygEditor
        },

        data () {
            return {
                readyToLoadBuyers: false,
                interested_buyers: [],
                buyerQuestionnaire_dialog: false,
                exporting: false,
                notesDialog: false,
                notesSaving: false,
                statusDrawer: false,
                selectedBuyers: [],
                selectedStatus: Number,
                options: {
                    itemsPerPage: -1,
                    multiSort: true
                },
                filterby: {
                    search: '',
                    status: [],
                    state: [],
                    aum: []
                },
                filtered_buyers_cnt: 0,
                moduleKey: 'buyer',
                moduleId: '5d357103-3744-4e52-885f-5247d42fa47b',
                disqualifiedBuyerStatusIds: [],
                all_buyers: [],
                buyer_status: [],
                buyerCounts: {
                    total_cnt: 0,
                    buyer_cnt: 0
                },
                listing_info: {},
                listing_identifier: '',
                thisBuyer: {},
                buyer_search: '',
                buyers_header: [
                    { text: 'Buyer Info',           value: 'buyer_fullname',        align: 'start',  sortable: true, width: "200px", class: 'tbl_headers' },
                    { text: 'State',                value: 'state',                 align: 'start',  sortable: true, width: "90px" },
                    { text: 'AUM',                  value: 'aum',                   align: 'start',  sortable: true, width: "100px" },
                    { text: 'Revenue',              value: 'recur_rev_pct',         align: 'start',  sortable: true, width: "120px" },
                    { text: 'AFP',                  value: 'afp_pct_rnk',           align: 'start',  sortable: true, width: "80px" },
                    { text: 'Commission',           value: 'commissions',           align: 'start',  sortable: true, width: "120px" },
                    { text: 'Broker Dealer',        value: 'broker_dealer',         align: 'start',  sortable: true, width: "230px" },
                    { text: 'Custodians',           value: 'custodians',            align: 'start',  sortable: true, width: "230px" },
                    { text: 'TAMPS',                value: 'tamps',                 align: 'start',  sortable: true, width: "230px" },
                    { text: 'DOI',                  value: 'created_date',          align: 'start',  sortable: true, width: "110px" },
                    { text: 'Buyer Compatibility',  value: 'compatibilitySortable', align: 'start',  sortable: true, width: "180px" },
                    { text: 'Adjusted Score',       value: 'adjustedScore',         align: 'start',  sortable: true, width: "150px" },
                    { text: 'Status',               value: 'rank',                  align: 'start',  sortable: true, width: "200px" }
                ],
                email: {
                    new_project_id: Number,
                    new_project_subject: String,
                    new_project_message: String,
                    new_module_name: String,
                    new_questionnaire_key: String
                },
                quickNotesToolbar,
                formulas: {
                    investmentPhilosophy: .1124,
                    clientPhilosophy: .1011,
                    expansionCapacity: .1011,
                    industryExperience: .0899,
                    brokerDealerCustodianTAMP: .0787,
                    officeInfrastrucfture: .0787,
                    financialPlanning: .0674,
                    teamSize: .0674,
                    designations: .0562,
                    proximity: .0449,
                    affiliations: .0449,
                    confidence: .0449,
                    trustworthiness: .0337,
                    reputation: .0225,
                    wow: .0225,
                    officeLocation: .0225,
                    personalityFit: .0112
                },
                sellerScore: 0,
                aum_ranges: [
                    { text: '0 - $250 million',             value: 'under_250m' },
                    { text: '$251 million - $500 million',  value: '250_500m'   },
                    { text: '$501 million - $750 million',  value: '500_750m'   },
                    { text: '$751 million - $1 billion',    value: '750_1b'     },
                    { text: '$1 billion +',                 value: 'over1b'     },
                ]
            }
        },

        computed: {
            // Unique, alphabetized list of every state across this listing's buyers
            state_options () {
                return [...new Set(this.all_buyers.map( buyer => buyer.state_text ))].sort( (a, b) => a.localeCompare(b) )
            },

            hasActiveFilters () {
                return this.buyer_search || this.filterby.status.length || this.filterby.state.length || this.filterby.aum.length ? true : false
            }
        },

        watch: {            
            buyer_search (val) {
                this.filterby.search = val || ''
                this.saveFilters()
            },

            listing_identifier (val) {
                document.title = `${val}: Buyers`;
            }
        },
        
        mounted () {
            this.readyToLoadBuyers = true
            this.loadSavedFilters();
            this.getBuyers();
            this.getLists();
        },
        
        methods: {     
            getDisqualifiedBuyerStatusIds: async function () {
                try {
                    const get_res = await axios.get(`${appUrls.api}/api/admin/disqualified_ids/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( get_res.data.outcome ) {
                        this.disqualifiedBuyerStatusIds = get_res.data.disqualified_ids
                    }
                } catch ( err ) {
                    console.log(error);
                }
            },

            getBuyerCounts: async function () {
                axios.get(`${appUrls.api}/api/admin/listing/${this.$route.params.lid}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    this.listing_info = res.data.listing
                    let this_Listing = res.data.listing
                    this.listing_identifier = this_Listing.listing_id;

                    // BUYERS OF TOTAL BUYERS
                    if ( this_Listing.total_buyers != 0 || undefined ) {
                        this.buyerCounts.buyer_cnt = this_Listing.buyer_count;
                        this.buyerCounts.total_cnt = this_Listing.total_buyers;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getBuyers: async function () {
                try { 
                    await this.getDisqualifiedBuyerStatusIds()
                    await this.getBuyerCounts()

                    const pull_buyers_rs = await axios.get(`${appUrls.api}/api/admin/buyers/${this.$route.params.lid}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                        
                    setTimeout(() => {
                        if( pull_buyers_rs.data.outcome ){

                            const buyers = pull_buyers_rs.data.buyers;

                            for (let b in buyers) {
                                buyers[b].state_text = buyers[b].state != 'ZZ' ? buyers[b].state : 'N/P';
                                
                                buyers[b].aum_text = buyers[b].aum != 0 ? formatBigInt(buyers[b].aum) : 'N/P';

                                buyers[b].revenue_vs_text = Object.keys(buyers[b].revenue_breakdown).length ? 'R: '+buyers[b].revenue_breakdown.rec+'%<br>T: '+buyers[b].revenue_breakdown.non+'%' : 'N/P';
                                buyers[b].recur_rev_pct = Object.keys(buyers[b].revenue_breakdown).length ? buyers[b].revenue_breakdown.rec : 0;

                                buyers[b].commissions = buyers[b].commissions != 'N/P' ? buyers[b].commissions ? 'Yes' : 'No' : 'N/P';

                                buyers[b].afp_pct = buyers[b].afp != -1 ? buyers[b].afp+'%' : 'N/P';
                                buyers[b].afp_pct_rnk = buyers[b].afp;

                                buyers[b].created_date_text = this.formatDate(buyers[b].created_date.substr(0,10), 2);
                                buyers[b].created_date = Date.parse(buyers[b].created_date.substr(0,10));

                                buyers[b].last_saved_date_text = buyers[b].last_saved_date != null ? this.formatDate(buyers[b].last_saved_date.substr(0, 10), 2) : 'N/A';

                                if ( buyers[b].questionnaire_progress != null ) {
                                    buyers[b].progress_color = 'accent';
                                    const sections = Array.isArray(buyers[b].questionnaire_sections) ? buyers[b].questionnaire_sections : null;
                                    const completed = sections ? sections.filter(s => s.is_complete).length : buyers[b].questionnaire_progress.finished;
                                    const total = sections ? sections.length : buyers[b].questionnaire_progress.total;
                                    buyers[b].show_progress = total > 0 ? (completed / total !== 1) : true;
                                    buyers[b].progress_text = `${completed} of ${total} sections completed`;
                                } else {
                                    buyers[b].progress_color = 'warning';
                                    buyers[b].show_progress = true;
                                    buyers[b].progress_text = `progress has not been calculated yet`;
                                }

                                buyers[b].status_change_date_text = buyers[b].status_change_date != null ? this.formatDate(buyers[b].status_change_date.substr(0, 10)) : '';
                                buyers[b].show_rejected_date = buyers[b].status_change_date != null && this.disqualifiedBuyerStatusIds.includes(buyers[b].status_id) ? true : false;
                            
                                buyers[b].custodians.sort();
                                buyers[b].tamps.sort();
                                buyers[b].compatibility = buyers[b].compatibility_score
                                buyers[b].adjustedScore = buyers[b].adjusted_compatibility_score
                                buyers[b].compatibilitySortable = buyers[b].compatibility ? (buyers[b].compatibility_score.split('/')[0] / buyers[b].compatibility_score.split('/')[1] * 100).toFixed(0) : 0
                            }

                            this.all_buyers = buyers;
                            this.selectedBuyers=[];
                            this.filterBuyers()
                        }
                    }, 1500)
                
                } catch ( error) {
                    console.log(error);
                }
            },

            filterBuyers: function () {
                try {
                    let filteredBuyers = this.all_buyers

                    // Drop any saved state that doesn't exist on this listing's buyers
                    this.filterby.state = this.filterby.state.filter( state => this.state_options.includes(state) )

                    // 1. Status Filter
                    if (this.filterby.status.length) {
                        filteredBuyers = filteredBuyers.filter( buyer => this.filterby.status.includes(buyer.status_id) )
                    }

                    // 2. State Filter
                    if (this.filterby.state.length) {
                        filteredBuyers = filteredBuyers.filter( buyer => this.filterby.state.includes(buyer.state_text) )
                    }

                    // 3. AUM Range Filter (same boundaries as the Search Buyers report)
                    if (this.filterby.aum.length) {
                        filteredBuyers = filteredBuyers.filter( buyer => this.filterby.aum.some( range => this.isInAumRange(buyer.aum, range) ) )
                    }

                    this.interested_buyers = filteredBuyers

                    // Don't let hidden buyers stay selected for a status change
                    const visibleIds = new Set(filteredBuyers.map( buyer => buyer.buyer_id ))
                    this.selectedBuyers = this.selectedBuyers.filter( buyer => visibleIds.has(buyer.buyer_id) )

                    this.saveFilters()
                    this.readyToLoadBuyers = false
                } catch ( err ) {
                    console.log(err)
                    return false
                }
            },

            isInAumRange: function ( aum, range ) {
                const value = Number(aum) || 0
                switch (range) {
                    case 'under_250m': return value >= 0 && value <= 250000000
                    case '250_500m':   return value > 250000000 && value <= 500000000
                    case '500_750m':   return value > 500000000 && value <= 750000000
                    case '750_1b':     return value > 750000000 && value <= 1000000000
                    case 'over1b':     return value > 1000000000
                    default:           return false
                }
            },

            filterOutRejected: function () {
                this.filterby.status = this.buyer_status
                    .filter( status => !this.disqualifiedBuyerStatusIds.includes(status.value) )
                    .map( status => status.value )
                this.filterBuyers()
            },

            clearFilters: function () {
                this.buyer_search = ''
                this.filterby = { search: '', status: [], state: [], aum: [] }
                this.filterBuyers()
            },

            loadSavedFilters: function () {
                try {
                    const savedOptions = safeParseJson(localStorage.getItem('buyerComparisonOptions'), null)
                    if ( savedOptions && typeof savedOptions === 'object' ) {
                        this.options = savedOptions
                    }

                    const savedFilters = safeParseJson(localStorage.getItem('buyerComparisonFilters'), null)
                    if ( savedFilters && typeof savedFilters === 'object' ) {
                        this.filterby.search = typeof savedFilters.search === 'string' ? savedFilters.search : ''
                        this.filterby.status = Array.isArray(savedFilters.status) ? savedFilters.status : []
                        this.filterby.state = Array.isArray(savedFilters.state) ? savedFilters.state : []
                        this.filterby.aum = Array.isArray(savedFilters.aum) ? savedFilters.aum : []
                        this.buyer_search = this.filterby.search
                    }
                } catch ( err ) {
                    console.log(err)
                }
            },

            saveFilters: function () {
                try {
                    localStorage.setItem('buyerComparisonFilters', JSON.stringify(this.filterby))
                } catch ( err ) {
                    console.log(err)
                }
            },

            onUpdateOptions: function ( newOptions ) {
                this.options = newOptions
                // Save sort options to localStorage
                try {
                    localStorage.setItem('buyerComparisonOptions', JSON.stringify(newOptions))
                } catch ( err ) {
                    console.log(err)
                }
            },

            getFilteredCount: function ( rs ) {
                this.filtered_buyers_cnt = rs.length
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green', feedback_duration=5000 ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color, feedback_duration );
            },

            openStatusDrawer () {
                if ( !this.selectedBuyers.length ) {
                    this.triggerUserFeedback( true, 'First select buyers to apply the status to.', 'accent', 3000 );

                    this.$nextTick(() => { this.selectedStatus = null });
                    return
                }

                this.statusDrawer = true;
            },

            statusUpdated (message) {
                this.triggerUserFeedback( true, message, 'light-green', 3000 );
                this.selectedStatus = null;
                this.selectedBuyers = [];

                setTimeout(() => {
                    this.getBuyers();
                }, 500)
            },
            
            buyerNotes (id) {
                let buyerObj = this.interested_buyers.find(obj => obj.id === id);
                this.thisBuyer = buyerObj;
                this.notesDialog = true;
            },

            saveNotes (buyer) {
                axios.post(`${appUrls.api}/api/admin/save_buyer_notes`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    buyer: buyer
                })
                .then( res => {
                    if ( res.data.outcome ) {
                        setTimeout(() => { this.notesSaving = true  }, 800);
                        setTimeout(() => { this.notesSaving = false }, 1800);
                    } else {
                        this.$feedback.error( res.data.message, 3000 );
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            exportBuyers: function () {
                this.exporting = true;
                axios.post(`${appUrls.api}/api/admin/export_buyers/${this.$route.params.lid}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    selected_buyers: this.selectedBuyers
                })
                .then( res => {
                    if( res.data.outcome ){
                        if ( res.data.count ) {
                            this.$feedback.success( res.data.message );
                            this.getBuyers(); // REFRESH BUYERS LIST

                            const this_fileExt = '.xlsx';
                            const this_fileDate = this.createDateString();
                            const this_fileData = new Buffer(res.data.buf, 'base64');
                            const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                            const this_fileName = this.listing_identifier+'-buyer-export_'+this_fileDate+this_fileExt;
                            
                            const this_blob = new Blob([this_fileData], {type: this_fileType});
                            saveAs(this_blob, this_fileName);

                        } else {
                            this.$feedback.success( res.data.message );
                        }
                    } else {
                        this.$feedback.error( 'There was a problem during the process of exporting buyers for this listing.' );
                    }
                    this.exporting = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            buyerQuestionnaire (buyer) {
                // console.log(buyer)
                this.thisBuyer = {}
                this.thisBuyer = buyer;
                this.thisBuyer.is_secondary = false
                this.thisBuyer.project_id = buyer.project_id

                setTimeout(()=>{
                    this.buyerQuestionnaire_dialog = true;
                }, 1000)
            },
            
            closeQuestionnaire: function () {
                this.thisBuyer = {}
                this.buyerQuestionnaire_dialog = false;
            },

            getLists: async function () {
                let optionsLists = [ 
                    {'name': 'buyer_status', 'type': 'int'},
                ];

                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'buyer_status') this.buyer_status = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            createDateString (date=false) {
                const d         = date ? new Date (date) : new Date()
                const year      = String(d.getFullYear())
                const month     = String(d.getMonth()+1).padStart(2, '0')
                const day       = String(d.getDate()).padStart(2, '0')
                const secs      = String(d.getSeconds())
                const msec      = String(d.getMilliseconds())
                return year.concat('', month.concat('', day.concat('', secs.concat('', msec))));
            },

            formatDate (date, digits_of_year=4) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${digits_of_year == 2 ? year.substr(2,2) : year}`;
            },

            closeBuyers: async function () {
                window.close()
            },
            getCompatibilityScore: async function (csvExport) {
              await axios.post(`${appUrls.api}/api/admin/calculate_buyer_scores/`, {
              headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
              data: {
                listing: this.listing_info,
                export: csvExport
              }
            })
            .then( res => {
                if(res.data.outcome){
                  this.getBuyers();
                }
                if (res.data.csvExport) {
                  if (res.data.csvExport.type === 'scores') {
                    const buyerScoreArrOptions = { 
                    filename: "Buyer Scores",
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    useTextFile: false,
                    useBom: true,
                    useKeysAsHeaders: false,
                  };
                  const buyerScoreArrCsvExporter = new ExportToCsv(buyerScoreArrOptions);
                  buyerScoreArrCsvExporter.generateCsv(res.data.csvExport.export);
                  }
                  if (res.data.csvExport.type === 'breakdown') {
                    const scoreBreakdownArrOptions = { 
                    filename: "Buyer Score Breakdown",
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    useTextFile: false,
                    useBom: true,
                    useKeysAsHeaders: true,
                  };
                  const scoreBreakdownArrCsvExporter = new ExportToCsv(scoreBreakdownArrOptions);
                  scoreBreakdownArrCsvExporter.generateCsv(res.data.csvExport.export);
                  }
              }
            })
            .catch(function (error) {
                console.log(error);
            });
            }
        }
}
</script>

<style scoped>
    #buyer_comparison_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 4rem 0 0 0;
        display: flex;
        flex-direction: column;
        /* height: 100vh; */
    }
    /* .buyers_table >>> td {
        padding-top: .25em !important;
        padding-bottom: .1em !important;
        padding-left: 0 !important; / * .15em * /
        padding-right: 0 !important;
        vertical-align: top !important;
        font-size: .9em !important;
    }
    .buyers_table >>> th {
        padding-left: 0 !important; / * .15em * /
        padding-right: 0 !important;
        font-size: .9em !important;
        background-color: #eef7f8 !important;
    } */

    ::v-deep .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        font-size: x-small;
        color: #333 !important;
        margin: 0 !important;
        height: 36px !important;
        border-top: 1px solid #EDEDED !important;
    }
    .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        font-size: small;
        /* border: 1px solid blue !important; */
    }
    tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
    ::v-deep tbody tr {
        cursor: pointer !important;
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }
    .title {
        padding: .5em;
    }
    #new_btn {
        width: 100%;
        text-align: right;
    }
    .listing_row {
        text-align: left;
    }
    .tbl_headers {
        padding: 0 !important;
    }
    /* .buyers_table >>> .v-data-table__wrapper::-webkit-scrollbar {
        display: none !important;
    }
    .buyers_table >>> .v-data-table__wrapper {
         -ms-overflow-style: none !important;  /* IE and Edge * /
        scrollbar-width: none !important;  /* Firefox * /
    } */

    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }

    .narrow-select-col >>> .v-data-table__checkbox {
        width: 32px !important;
        min-width: 32px !important;
        max-width: 32px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .narrow-select-col >>> th.v-data-table__checkbox {
        width: 32px !important;
        min-width: 32px !important;
        max-width: 32px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/BuyerComparison.vue